// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer_j4JeT","actions":"AppFooter_actions_9ZW77","btnToggle":"AppFooter_btnToggle_1feZN","hidden":"AppFooter_hidden_3lzjU"};